import { PriorityBadge, StatusSelect, ScoreBadge, DraftBadge } from "./Badges";
import { STATUSES } from "./constants";

export default function ContactsTable({ contacts, onOpen, onStatus }) {
  if (!contacts.length) {
    return <div className="card p-10 text-center text-sm" style={{ color: "var(--text-2)" }} data-testid="empty-state">No targets match these filters.</div>;
  }
  return (
    <div className="table-wrap" data-testid="contacts-table">
      <table className="crm">
        <thead>
          <tr>
            <th>Target</th><th>Role · Category</th><th>Priority</th><th>Score</th><th>Sound fit</th><th>Contact route</th><th>ADE presence</th><th>Status</th><th>Reply</th><th>Meeting</th>
          </tr>
        </thead>
        <tbody>
          {contacts.map((c) => (
            <tr key={c.id} className="row" onClick={() => onOpen(c)} data-testid={`contact-row-${c.id}`}>
              <td className="min-w-[200px]">
                <div className="font-semibold" data-testid={`contact-name-${c.id}`}>{c.targetName}</div>
                <div className="text-xs mt-0.5" style={{ color: "var(--text-2)" }}>{c.company}</div>
                <div className="mt-1.5"><DraftBadge contact={c} testId={`draft-badge-${c.id}`} /></div>
              </td>
              <td className="min-w-[150px]">
                <div className="text-xs">{c.role}</div>
                <div className="mono text-[10px] mt-1 uppercase tracking-wider" style={{ color: "var(--muted)" }}>{c.category}</div>
              </td>
              <td><PriorityBadge value={c.priority} /></td>
              <td><ScoreBadge value={c.replyScore} testId={`score-badge-${c.id}`} /></td>
              <td className="min-w-[260px] max-w-[320px] text-xs leading-relaxed" style={{ color: "var(--text-2)" }}>{c.soundFitNotes}</td>
              <td className="min-w-[220px] max-w-[280px] text-xs leading-relaxed">
                <div style={{ color: "var(--text-2)" }}>{c.publicContactRoute}</div>
                {c.email && <div className="mono text-[11px] mt-1" style={{ color: "var(--cyan)" }}>{c.email}</div>}
              </td>
              <td className="min-w-[220px] max-w-[280px] text-xs leading-relaxed" style={{ color: "var(--text-2)" }}>{c.cityNotes}</td>
              <td>
                <StatusSelect value={c.outreachStatus} options={STATUSES} onChange={(v) => onStatus(c, v)} testId={`status-select-${c.id}`} />
              </td>
              <td className="text-xs" style={{ color: c.reply === "Yes" ? "var(--emerald)" : "var(--text-2)" }}>{c.reply}</td>
              <td className="text-xs min-w-[120px]" style={{ color: "var(--text-2)" }}>
                {c.adeMeetingDate ? <><div className="mono" style={{ color: "var(--emerald)" }}>{c.adeMeetingDate}</div><div>{c.adeMeetingLocation}</div></> : "—"}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
